import { Vue, Component } from 'vue-property-decorator'
import { loginGuard } from '@/galaxy-cruise/utils';
import { api } from '@/galaxy-cruise/api';
import { i18nTranslate } from '@/i18n';

@Component
export default class extends Vue {
  static beforeEnter = loginGuard

  cancel() {
    this.$router.back()
  }

  async  submit() {
    const axios = api.default
    await axios.delete('../api/v1/user')
    alert(i18nTranslate({
      ja: 'アカウントが削除されました。\nご利用ありがとうございました。',
      en: 'Your account was deleted.\nThank you.',
    }))
    location.href = '..'
  }
}
